export const GAME_MODE = {
  CLASSIC: 'classic',
  ADVANCED_CAPACITY: 'advancedCapacity'
};

export const DEFAULT_GAME_MODE = GAME_MODE.CLASSIC;

export const GAME_MODE_LABEL = {
  [GAME_MODE.CLASSIC]: 'Classic',
  [GAME_MODE.ADVANCED_CAPACITY]: 'Advanced'
};

export const CLASSIC_GAME_VERSION = 'v2.4';
export const ADVANCED_CAPACITY_GAME_VERSION = 'advanced-capacity-v1.0';

export const GAME_VERSION_BY_MODE = {
  [GAME_MODE.CLASSIC]: CLASSIC_GAME_VERSION,
  [GAME_MODE.ADVANCED_CAPACITY]: ADVANCED_CAPACITY_GAME_VERSION
};
